var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMarketingSocialMediaIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45.366,
    height: 41.75,
    viewBox: "0 0 45.366 41.75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    transform: "translate(-6.731 -0.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M46.708,21.866a5.345,5.345,0,0,0-5.342-9.26L36.023,3.355a.874.874,0,0,0-1.621.267,28.982,28.982,0,0,1-5.609,12.216,24.851,24.851,0,0,1-6.064,5.485l-7.675,4.452A.89.89,0,0,0,14.725,27l-.775.445a6.233,6.233,0,0,0,3.116,11.611,6.144,6.144,0,0,0,3.1-.837l.775-.445a.89.89,0,0,0,.543.418.97.97,0,0,0,.231,0,.89.89,0,0,0,.445-.116L22.284,38l5.342,6.348a.9.9,0,0,0,1.122.2l4.8-2.769a.89.89,0,0,0,.427-.614.828.828,0,0,0-.2-.73l-5.129-6.108,1.193-.695a25.207,25.207,0,0,1,7.782-2.5,28.849,28.849,0,0,1,13.427,1.247.84.84,0,0,0,.962-1.255ZM44.927,13.8a3.545,3.545,0,0,1,.89,6.518l-1.781-3.081-1.781-3.081a3.562,3.562,0,0,1,2.707-.356ZM19.275,36.674a4.452,4.452,0,1,1-4.452-7.711l.775-.445,4.452,7.711Zm2.76-.561-5.342-9.26,6.17-3.562,5.342,9.26-1.353.775-3.116,1.781Zm9.705,4.675-3.232,1.87-4.657-5.538,3.223-1.861Zm5.618-11.4a27.041,27.041,0,0,0-7.586,2.315L27.1,27.031,24.43,22.356a26.712,26.712,0,0,0,5.8-5.414A30.131,30.131,0,0,0,35.649,6.169l4.675,8.1,4.452,7.711,4.683,8.1A30.149,30.149,0,0,0,37.359,29.39Z",
    transform: "translate(-4.136 -2.219)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M55.81,15.061a.89.89,0,0,0,.445-.116l3.081-1.781a.893.893,0,0,0-.89-1.549L55.364,13.4a.89.89,0,0,0,.445,1.665Z",
    transform: "translate(-8.964 -3.16)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M50.111,10.627a.73.73,0,0,0,.231,0,.89.89,0,0,0,.89-.659l.89-3.446a.89.89,0,0,0-1.718-.463l-.89,3.446a.89.89,0,0,0,.6,1.122Z",
    transform: "translate(-8.368 -2.493)",
    fill: "#009dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M60.375,21.286l-3.437-.89a.89.89,0,1,0-.463,1.718l3.437.89h.232a.9.9,0,0,0,.231-1.781Z",
    transform: "translate(-9.06 -4.132)",
    fill: "#009dd7"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarketingSocialMediaIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/marketing-social-media-icon.64ceea7b.svg";
export { ForwardRef as ReactComponent };